var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8452 12.7633L29.0128 0.0664062H26.3665L16.6698 11.0911L8.92493 0.0664062H-0.0078125L11.7038 16.7375L-0.0078125 30.0523H2.63879L12.879 18.41L21.058 30.0523H29.9908L17.8449 12.7633H17.8457H17.8452ZM14.2204 16.8843L13.0337 15.2243L3.59223 2.0149H7.65701L15.2766 12.6753L16.4633 14.3352L26.3677 28.1921H22.3029L14.2206 16.8847V16.884L14.2204 16.8843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/X Logo.f18e026d0bb21b8c909dd3df49245521.svg";
export { ForwardRef as ReactComponent };